import React from 'react';
import { motion } from 'framer-motion';
import { Button } from '../ui/button';
import { Phone, MessageCircle } from 'lucide-react';

const HeroCTA = ({ onWhatsApp, onCall, phoneNumber }) => (
  <>
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8, delay: 0.6 }}
      className="flex flex-col sm:flex-row gap-4 justify-center mb-10"
    >
      <Button
        size="lg"
        onClick={onWhatsApp}
        className="bg-gradient-to-r from-green-600 to-emerald-600 hover:from-green-700 hover:to-emerald-700 text-white px-8 py-7 text-lg rounded-2xl shadow-2xl shadow-green-500/20 hover:shadow-green-500/40 transition-all duration-300 transform hover:scale-105 hover:-translate-y-1 border border-green-500/20"
        data-testid="hero-whatsapp-btn"
      >
        <MessageCircle className="w-5 h-5 mr-2" />
        Fotos per WhatsApp senden
      </Button>
      <Button
        size="lg"
        onClick={onCall}
        className="bg-slate-800/50 hover:bg-slate-700/50 backdrop-blur-sm border-2 border-blue-500/50 text-white px-8 py-7 text-lg rounded-2xl shadow-2xl shadow-blue-500/20 hover:shadow-blue-500/40 transition-all duration-300 transform hover:scale-105 hover:-translate-y-1"
        data-testid="hero-call-btn"
      >
        <Phone className="w-5 h-5 mr-2" />
        Jetzt anrufen: {phoneNumber}
      </Button>
    </motion.div>

    <motion.p
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.8, delay: 0.8 }}
      className="text-slate-400 text-lg mb-12"
    >
      Spezialisiert auf Wohnungsabgaben, weiße Standardanstriche und schnelle Termine in Zürich und Umgebung.
    </motion.p>
  </>
);

export default HeroCTA;
